export default __webpack_public_path__ + "static/media/step7-2.b5a26cfa.jpg";